<template>
  <div>
    Launching in:
    <Countdown deadline="2021-12-25 00:00:00"/>
  </div>
</template>

<script>
import Countdown from 'vuejs-countdown'
export default {
  name: 'App',
  components: {
    Countdown
  }
}
</script>
